import { Colors, Fonts } from '../../../../shared/theme/';
import fonts from '../../../../shared/theme/fonts';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20,
  } as React.CSSProperties,
  defaultContentNotFound: {
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '20px',
    height: '56px'
  } as React.CSSProperties,
  selectedMenuItem: {
    backgroundColor: '#FCF4FA'
  },
  searchBox: {
    padding: '14px 10px'
  },
  textRegular12Gray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.gray
  },
  buttonPos: {
    color: Colors.lightPurple,
    borderColor: Colors.lightPurple,
    borderRadius: '4px',
    background: 'transparent',
    ...fonts.style.textRegularHeader,
    height: '40px',
    marginRight: '16px'
  },
  posIcon: {
    width: '14px',
    height: '16px',
    marginRight: '8px'
  },
  paddingTop20: {
    paddingTop: '20px',
  },
  remarkTextRegular14Gray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.darkGray,
    paddingTop: '20px'
  },
  tagPs01: {
    color: Colors.tagRed,
    background: Colors.tagPalered,
    border: '1px solid',
    borderColor: Colors.tagLightred
  },
  tagPs02: {
    color: Colors.tagYellow,
    background: Colors.tagPaleyellow,
    border: '1px solid',
    borderColor: Colors.tagLightyellow
  },
  tagPs03withDate: {
    color: Colors.tagGreen,
    background: Colors.tagPalegreen,
    border: '1px solid',
    borderColor: Colors.tagLightgreen
  },
  tagPs03noDate: {
    color: Colors.white,
    background: Colors.tagGreen,
  },
  tagPs04: {
    color: Colors.white,
    background: Colors.tagRed,
  },
  posStatusLink: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    textDecoration: 'underline',
    color: Colors.lightPurple,
    cursor: 'pointer',
    marginTop: '8px'
  },
  textDesc: {
    width: '160px',
    display: 'flex',
  },
  regularPurple14under: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    textDecoration: 'underline',
    color: Colors.lightPurple,
    cursor: 'pointer',
  },
};
